/**
 * Vuex Store
 *
 * @requires vue
 * @requires vuex
 */

// Dependencies
import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseMutations } from 'vuexfire'

// Install
Vue.use(Vuex)

// Modules
import modules from './modules'

// Export
export default new Vuex.Store({
	mutations: {
		...firebaseMutations,
	},
	modules,
})



// WEBPACK FOOTER //
// ./src/lib/store/index.js